import { useEffect } from 'react';
import Wordcloud from 'wordcloud';

/**
 * Hook to handle rendering the wordcloud
 *
 * @param {Object} params - Parameters for rendering the wordcloud
 * @param {Object} params.canvasRef - Reference to the canvas element
 * @param {Wordcloud.Options} params.config - Configuration for the wordcloud
 * @param {Array} params.words - Array of word objects
 * @returns {void}
 */
export const useWordCloudRenderer = ({ canvasRef, config, words }) => {
  // Render the wordcloud when the configuration changes
  useEffect(() => {
    if (words.length && canvasRef.current && config) {
      Wordcloud(canvasRef.current, config);
    }
  }, [canvasRef, config, words]);

  // Clean up the wordcloud when the component unmounts
  useEffect(() => {
    return () => {
      Wordcloud.stop();
    };
  }, []);
};
